import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Paper } from '@mui/material';

import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { Group } from '../../organisms/group';
import { useSelector } from '../../store/utils';
import { SwitchBox } from '../../molecules/switch-box';
import { ValueBox } from '../../molecules/value-box';
import { reverse } from 'lodash';
import { SimpleTable } from '../../molecules/simple-table';
import { FormattedDateTime } from '../../utils/formatted-datetime';
import { FlexibilityTest } from '../../organisms/flexibility/flexibility-command-test';
import { FlexibilityCommandType } from '../../shared';

const Electree = () => {
  const [serviceActive, connected, lastMessages, activeCommand] = useSelector(
    ({ variables }) =>
      [
        variables.SERVICE_ACTIVE,
        variables.ELECTREE_API_CONNECTED,
        variables.ELECTREE_API_LAST_MESSAGES,
        variables.FLEXIBILITY_ACTIVE_COMMAND,
      ] as const
  );

  const lastMessagesReversed = useMemo(() => {
    return reverse(lastMessages ? [...lastMessages] : []);
  }, [lastMessages]);

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage id="electree.title" defaultMessage="Electree" />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <>
      <Group
        layout="list"
        title={
          <FormattedMessage id="electree.title" defaultMessage="Electree" />
        }
      >
        <SwitchBox
          switchVariableId="ELECTREE_API_ENABLED"
          title={
            <FormattedMessage
              id="electree.enabled"
              defaultMessage="Integrace zapnuta"
            />
          }
          fullWidth
        />
        <ValueBox
          type="row"
          title={
            <FormattedMessage id="electree.connected" defaultMessage="Stav" />
          }
          value={connected ? 'Online' : 'Nepřipojeno'}
        />

        <SimpleTable
          title={
            <FormattedMessage
              id="electree.last_messages"
              defaultMessage="Poslední zprávy"
            />
          }
          rows={[
            [
              <FormattedMessage
                id="electree.last_messages.date"
                defaultMessage="Čas"
                key={0}
              />,
              <FormattedMessage
                id="electree.last_messages.topic"
                defaultMessage="Topic"
                key={1}
              />,
              <FormattedMessage
                id="electree.last_messages.payload"
                defaultMessage="Zpráva"
                key={2}
              />,
            ],
            ...lastMessagesReversed.map(({ date, payload, topic }) => {
              return [
                <FormattedDateTime value={date} key={0} />,
                JSON.stringify(topic),
                JSON.stringify(payload),
              ];
            }),
          ]}
          lastColBold={false}
          firstColBold={false}
          firstLineBold={true}
        />
      </Group>

      <Group
        layout="list"
        title={
          <FormattedMessage
            id="electree.business_flexibility.title"
            defaultMessage="Obchodní flexibilita"
          />
        }
      >
        <FlexibilityTest type={FlexibilityCommandType.Electree} />

        <Paper>{JSON.stringify(activeCommand)}</Paper>
      </Group>
    </>
  );
};

export default Electree;
